import store from '@/state/store'

export default [
    {
        path: '/',
        name: 'index',
        component: () => import('./views/index'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    //Fazer o redirecionamento quando estiver logado
                    next({name: 'painel'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/public/nota/:not_hash',
        name: 'public-nota',
        component: () => import('./views/nota-validada'),
    },
    {
        path: '/painel',
        name: 'painel',
        meta: {
            empresa: false,
            authRequired: true,
        },
        component: () => import('./views/dashboards/default'),
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'painel'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/confirmacao/:tus_codigo',
        name: 'Confirmacao',
        component: () => import('./views/account/confirmacao')
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () => import('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'painel'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/recover/:ahr_hash',
        name: 'RecuperacaoSenha',
        component: () => import('./views/account/recover')
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('auth/logOut')
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {name: 'default'} : {...routeFrom})
            },
        },
    },
    // {
    //   path: '/404',
    //   name: '404',
    //   component: require('./views/utility/404').default,
    // },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '/contribuinte/empresas',
        name: 'contribuinte-empresas',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/empresas.vue')
    },
    {
        path: '/contribuinte/solicitacao',
        name: 'contribuinte-solicitacao',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao')
    },
    {
        path: '/contribuinte/solicitacao/visualizar/:tps_hash',
        name: 'contribuinte-solicitacao-visualizar',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-visualizacao')
    },
    {
        path: '/contribuinte/solicitacao/fisica/autonomo/:tps_hash?',
        name: 'contribuinte-solicitacao-fisica-autonomo',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-fisica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA FÍSICA - AUTÔNOMOS',
            tps_tipo: 1
        }
    },
    {
        path: '/contribuinte/solicitacao/fisica/avulso/:tps_hash?',
        name: 'contribuinte-solicitacao-fisica-avulso',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-fisica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA FÍSICA - AVULSOS',
            tps_tipo: 2
        }
    },
    {
        path: '/contribuinte/solicitacao/juridica/prestador/:tps_hash?',
        name: 'contribuinte-solicitacao-juridica-prestador',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-juridica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA JURÍDICA - PRESTADORES',
            tps_tipo: 3
        }
    },
    {
        path: '/contribuinte/solicitacao/juridica/nao-prestador/:tps_hash?',
        name: 'contribuinte-solicitacao-juridica-nao-prestador',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-juridica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA JURÍDICA - NÃO PRESTADORES',
            tps_tipo: 4
        }
    },
    {
        path: '/contribuinte/solicitacao/juridica/contabilidade/:tps_hash?',
        name: 'contribuinte-solicitacao-juridica-contabilidade',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-juridica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA JURÍDICA - ESCRITÓRIOS DE CONTABILIDADE',
            tps_tipo: 5
        }
    },
    {
        path: '/contribuinte/solicitacao/juridica/cartorio/:tps_hash?',
        name: 'contribuinte-solicitacao-juridica-cartorio',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/solicitacao-pessoa-juridica'),
        props: {
            page_title: 'SOLICITAÇÃO - PESSOA JURÍDICA - CARTÓRIOS',
            tps_tipo: 6
        }
    },
    {
        path: '/contribuinte/solicitacao/historico/:ceh_codigo',
        name: 'contribuinte-solicitacao-historico',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/historico'),
    },
    {
        path: '/contribuinte/empresa',
        name: 'contribuinte-empresa',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/dados-empresa'),
    },
    {
        path: '/contribuinte/nota-fiscal/lista',
        name: 'contribuinte-nota-fiscal-lista',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/nota_fiscal/notas'),
    },
    {
        path: '/contribuinte/nota-fiscal/gerar',
        name: 'contribuinte-nota-fiscal-gerar',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/nota_fiscal/criar-nota'),
    },
    {
        path: '/contribuinte/nota-fiscal/substituir/:not_hash',
        name: 'contribuinte-nota-fiscal-substituir',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/nota_fiscal/substituicao-nota'),
    },
    {
        path: '/contribuinte/nota-fiscal/visualizar/:not_hash',
        name: 'contribuinte-nota-fiscal-visualizar',
        meta: {authRequired: true, empresa: false},
        component: () => import('./views/nota_fiscal/visualizar-nota'),
    },
    {
        path: '/contribuinte/nota-fiscal/cancelar',
        name: 'contribuinte-nota-fiscal-cancelar',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/nota_fiscal/cancelar-nota'),
    },
    {
        path: '/contribuinte/nota-fiscal/cancelamentos',
        name: 'contribuinte-nota-fiscal-cancelamentos',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/nota_fiscal/cancelamentos'),
    },
    {
        path: '/contribuinte/ranfs/lista',
        name: 'contribuinte-ranfs-lista',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/ranfs/ranfs'),
    },
    {
        path: '/contribuinte/ranfs/gerar',
        name: 'contribuinte-ranfs-gerar',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/ranfs/criar-ranf'),
    },
    {
        path: '/contribuinte/ranfs/visualizar/:ran_hash',
        name: 'contribuinte-ranfs-visualizar',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/ranfs/visualizar-ranfs'),
    },
    {
        path: '/contribuinte/financeiro/guia',
        name: 'contribuinte-financeiro-guia',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/financeiro/guia'),
    },
    {
        path: '/contribuinte/financeiro/guia/:dam_hash',
        name: 'contribuinte-financeiro-guia-detalhe',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/financeiro/guia-detalhe'),
    },
    {
        path: '/contribuinte/financeiro/pagamento/:dam_hash',
        name: 'contribuinte-financeiro-pagamento',
        meta: {authRequired: true, empresa: false},
        component: () => import('./views/contribuinte/financeiro/pagamento.vue'),
    },
    {
        path: '/contribuinte/financeiro/fechamento-parcial',
        name: 'contribuinte-financeiro-fechamento-parcial',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/financeiro/fechamento_parcial'),
    },
    {
        path: '/contribuinte/financeiro/declaracao-mensal',
        name: 'contribuinte-financeiro-declaracao-mensal',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/financeiro/declaracao-mensal'),
    },

    /* RELATÓRIOS */
    {
        path: '/contribuinte/relatorios/notas-fiscais',
        name: 'contribuinte-relatorios-notas-fiscais',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/relatorios/rel-notas-fiscais.vue'),
        props: {
            tipo: 'NOTAS'
        }
    },
    {
        path: '/contribuinte/relatorios/duam',
        name: 'contribuinte-relatorios-duam',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/relatorios/rel-duam.vue'),
        props: {
            tipo: 'DUAM'
        }
    },
    {
        path: '/contribuinte/relatorios/livro-fiscal',
        name: 'contribuinte-relatorios-livro-fiscal',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/relatorios/rel-livro-fiscal.vue'),
    },
    {
        path: '/contribuinte/simples/fiscalizacao',
        name: 'contribuinte-simples-fiscalizacao',
        meta: {authRequired: true, empresa: true},
        component: () => import('./views/contribuinte/simples/simples-fiscalizacao.vue'),
    },

    /* Share */
    /* Share */
    /* Share */

    {
        path: '/share/cancelamentos/detalhe/:tipo/:codigo',
        name: 'share-cancelamentos-detalhe',
        meta: {authRequired: true},
        component: () => import('./views/share/cancelamento_detalhe'),
    },

    /* ADMIN */
    /* ADMIN */
    /* ADMIN */
    /* ADMIN */
    {
        path: '/admin/painel',
        name: 'admin-painel',
        meta: {authRequired: true},
        component: () => import('./views/admin/painel.vue'),
    },
    {
        path: '/admin/nfse/consulta',
        name: 'admin-nfse-consulta',
        meta: {authRequired: true},
        component: () => import('./views/admin/nfse/consulta-nfse.vue'),
    },
    {
        path: '/admin/nfse/importadas',
        name: 'admin-nfse-importadas',
        meta: {authRequired: true},
        component: () => import('./views/admin/nfse/importadas-nfse.vue'),
    },
    {
        path: '/admin/liberacao/pessoa',
        name: 'admin-liberacao-pessoa',
        meta: {authRequired: true},
        component: () => import('./views/admin/liberacao/pessoas'),
    },
    {
        path: '/admin/liberacao/pessoa/detalhe/:tps_hash',
        name: 'admin-liberacao-pessoa-detalhe',
        meta: {authRequired: true},
        component: () => import('./views/admin/liberacao/liberacao-detalhe'),
    },
    {
        path: '/admin/pessoas/usuarios',
        name: 'admin-pessoas-usuarios',
        meta: {authRequired: true},
        props: {
            aguardando: true
        },
        component: () => import('./views/admin/pessoas/usuarios'),
    },
    {
        path: '/admin/pessoas/usuarios/sem_confirmacao',
        name: 'admin-pessoas-usuarios-sem-confirmacao',
        meta: {authRequired: true},
        props: {
            aguardando: false
        },
        component: () => import('./views/admin/pessoas/usuarios_aguardando'),
    },
    {
        path: '/admin/pessoas/usuarios/detalhe/:tipo/:hash',
        name: 'admin-pessoas-usuarios-detalhe',
        meta: {authRequired: true},
        component: () => import('./views/admin/pessoas/usuarios_detalhe'),
    },
    {
        path: '/admin/pessoas/autorizadas',
        name: 'admin-pessoas-autorizadas',
        meta: {authRequired: true},
        component: () => import('./views/admin/pessoas/empresas_autorizadas'),
    },
    {
        path: '/admin/pessoas/autorizadas/detalhe/:eco_codigo',
        name: 'admin-pessoas-autorizadas-detalhe',
        meta: {authRequired: true},
        component: () => import('./views/admin/pessoas/empresas_autorizadas_detalhe'),
    },
    {
        path: '/admin/gestao/fechamento',
        name: 'admin-gestao-fechamento',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/fechamento_mensal'),
    },
    {
        path: '/admin/gestao/duams_emitidas',
        name: 'admin-gestao-duams-emitidas',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/duams_emitidas'),
    },
    {
        path: '/admin/gestao/retorno_pagamento',
        name: 'admin-gestao-retorno-pagamento',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/retorno_pagamento'),
    },
    {
        path: '/admin/gestao/remessa_tse',
        name: 'admin-gestao-remessa-tse',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/remessa_tse'),
    },
    {
        path: '/admin/gestao/pedidos_cancelamento',
        name: 'admin-gestao-pedidos-cancelamento',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/pedidos_cancelamento'),
    },
    {
        path: '/admin/gestao/nfse_nacional',
        name: 'admin-gestao-nfse-nacional',
        meta: {authRequired: true},
        component: () => import('./views/admin/gestao/nfse_nacional'),
    },

    {
        path: '/admin/fiscalizacao/simples_nacional',
        name: 'admin-fiscalizacao-simples-nacional',
        meta: {authRequired: true},
        component: () => import('./views/admin/fiscalizacao/simples_nacional.vue'),
    },
    {
        path: '/admin/fiscalizacao/simples_nacional/apuracao/:eco_codigo/:eco_cnpj',
        name: 'admin-fiscalizacao-simples-nacional-apuracao',
        meta: {authRequired: true},
        component: () => import('./views/contribuinte/simples/simples-fiscalizacao.vue'),
    },
    {
        path: '/admin/fiscalizacao/simples_nacional/divergencias/:esr_cnpj',
        name: 'admin-fiscalizacao-simples-nacional-divergencias',
        meta: {authRequired: true},
        component: () => import('./views/admin/fiscalizacao/simples_nacional_divergencias.vue'),
    },
    {
        path: '/admin/fiscalizacao/simples_nacional/notificacoes',
        name: 'admin-fiscalizacao-simples-nacional-notificacao',
        meta: {authRequired: true},
        component: () => import('./views/admin/fiscalizacao/notificacao.vue'),
    },

    {
        path: '/admin/configuracoes/geral',
        name: 'admin-configuracoes-geral',
        meta: {authRequired: true},
        component: () => import('./views/admin/configuracoes/geral'),
    },
    /* FIM ADMIN */

    // Redirect any unmatched routes to the 404 page. This may
    {
        path: "*",
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                next({name: 'painel'})
            },
        },
    }

]
